export const isEmpty = value => (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0) 
) && typeof value != 'number' && typeof value != 'boolean'
export default isEmpty